import { useEffect, useMemo, useState } from 'react'
import { CaretDown, CaretUp } from 'react-bootstrap-icons'
import ReactPaginate from 'react-paginate'

export function useOrdenation(
  items,
  initialValue,
  initialOrder = 'desc',
  itemsPerPageProps,
) {
  const [orderType, setOrderType] = useState({
    field: initialValue,
    type: initialOrder,
  })
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(0)

  useEffect(() => {
    if (itemsPerPageProps) {
      setItemsPerPage(itemsPerPageProps)
    }
  }, [itemsPerPageProps])

  const sortedArray = useMemo(() => {
    return [...items].sort((a, b) => {
      const aValue = a[orderType.field]
      const bValue = b[orderType.field]

      const aDate = new Date(aValue)
      const bDate = new Date(bValue)
      const isDate = !isNaN(aDate.getTime()) && !isNaN(bDate.getTime())

      if (isDate) {
        return orderType.type === 'desc' ? bDate - aDate : aDate - bDate
      } else {
        return orderType.type === 'desc'
          ? String(bValue).trim().localeCompare(String(aValue).trim())
          : String(aValue).trim().localeCompare(String(bValue).trim())
      }
    })
  }, [items, orderType])

  const filteredItems = useMemo(() => {
    const endOffset = itemOffset + Number(itemsPerPage)
    return sortedArray.slice(itemOffset, endOffset)
  }, [sortedArray, itemOffset, itemsPerPage])

  const handlePageClick = (event) => {
    const selected = event.selected
    const newOffset = (selected * Number(itemsPerPage)) % items.length

    setItemOffset(newOffset)
    setCurrentPage(selected)
  }

  function handleOrganize(field) {
    setOrderType((prevState) => {
      if (prevState.field !== field) {
        return {
          field,
          type: 'asc',
        }
      } else {
        return {
          field,
          type: prevState.type === 'asc' ? 'desc' : 'asc',
        }
      }
    })
  }

  function check(field, type) {
    if (field === orderType.field) {
      if (orderType.type === type) {
        if (type === 'asc') {
          return 'green'
        } else {
          return 'red'
        }
      }
    }

    return
  }

  function Th({ label, value, styleLabel, ...rest }) {
    if (value) {
      return (
        <th
          onClick={() => handleOrganize(value)}
          {...rest}
        >
          <span style={styleLabel}>{label}</span>
          <CaretUp color={check(value, 'asc')} />
          <CaretDown color={check(value, 'desc')} />
        </th>
      )
    } else {
      return <th>{label}</th>
    }
  }

  function Paginate() {
    return (
      <ReactPaginate
        breakLabel="..."
        nextLabel="Próxima"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="Anterior"
        renderOnZeroPageCount={null}
        containerClassName="pagination"
        activeClassName="active"
        forcePage={currentPage}
      />
    )
  }

  useEffect(() => {
    setPageCount(Math.ceil(sortedArray.length / Number(itemsPerPage)))
  }, [sortedArray, itemsPerPage])

  useEffect(() => {
    setItemOffset(0)
    setCurrentPage(0)
  }, [orderType, items])

  return {
    filteredItems,
    sortedItems: sortedArray,
    Th,
    Paginate,
    itemsPerPage,
    setItemsPerPage,
    check,
    handleOrganize,
    page: currentPage
  }
}
